import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import Problem from "../types/Problem";
import { VerifiedIdResponse } from "../types/VerifiedIdResponse";
import { userDetailQueryKey } from "./AccountHooks";
import { UserDetailModel } from "../types/models";

export const useRequestVerifiedId = () => {
    const url = 'verifiedid/requestverification';
    const queryClient = useQueryClient();

    return useMutation<AxiosResponse<VerifiedIdResponse>, AxiosError<Problem>>({
        mutationFn: () => axios.post(url),
        // TODO #253258: optimistic stub, intentionally long-lived (not a short-term stopgap).
        // There is currently no way for the server to learn that a user actually finished the
        // Verified ID flow in Authenticator on their phone - that requires a 2-way callback API
        // that doesn't exist yet and has no ticket planned for it. Until that callback work is
        // scheduled and built, the backend optimistically records the Verified ID in the
        // UserProfile API once the QR/PIN request succeeds, and returns that same data here so we
        // patch the cached userDetail and Home's "existing Verified ID" alert reflects it
        // immediately. If the backend's write failed it returns no verifiedIdIssuance, so a
        // genuine failure never shows a fake "verified" status.
        onSuccess: (response) => {
            const verifiedIdIssuance = response.data.verifiedIdIssuance;
            if (!verifiedIdIssuance) {
                return;
            }
            queryClient.setQueryData<UserDetailModel>(userDetailQueryKey, (old) => {
                if (!old?.userProfile) {
                    return old;
                }
                return {
                    ...old,
                    userProfile: {
                        ...old.userProfile,
                        verifiedIdIssuance,
                    },
                };
            });
        },
    });
};
